import React, { FC, useMemo } from 'react';
import { Select, SelectProps } from 'antd';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { NoContentItem } from '../../components';
import translations from './EntityFilterSelect.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('entity-filter');
addTranslations(translations);

export interface EntityFilterSelectProps<T extends string | number = number>
  extends Omit<SelectProps, 'options'> {
  options: { id: T; name: string; code?: string }[];
  showCode?: boolean;
}

export const EntityFilterSelect: FC<EntityFilterSelectProps> = (props) => {
  const { options, dropdownStyle, showCode, ...rest } = props;
  const { t } = useTranslation();
  const selectOptions = useMemo(
    () =>
      options.map((item) => ({
        label: showCode ? `${item.code ?? ''} - ${item.name}` : item.name,
        value: item.id,
      })),
    [options, showCode]
  );
  return (
    <Select
      mode="multiple"
      placeholder={t('placeholder')}
      allowClear={Boolean(props.onClear)}
      optionFilterProp="label"
      notFoundContent={<NoContentItem />}
      {...rest}
      options={selectOptions}
      styles={{
        popup: { root: { width: 'max-content', ...dropdownStyle } },
      }}
    />
  );
};
